import z from "zod";

export const createServiceOrderSchema = z.object({
  title: z.string().min(1, "Título é obrigatório"),
  description: z.string().min(1, "Descrição é obrigatória"),
  priority: z.enum(["LOW", "MEDIUM", "HIGH", "URGENT"], {
    message: "Prioridade é obrigatória",
  }),
  sectorId: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Setor é obrigatório",
    }),
  assignedToId: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Responsável é obrigatório",
    }),
  assignedTeamId: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: "Equipe é obrigatória",
    }),
  estimatedStartDate: z
    .string()
    .min(1, "Data de início estimada é obrigatória"),
  estimatedEndDate: z.string().min(1, "Data de término estimada é obrigatória"),
  occurrenceIds: z.array(z.string()),
});

export type CreateServiceOrderFormData = z.infer<
  typeof createServiceOrderSchema
>;

export const updateServiceOrderSchema = z.object({
  title: z.string().min(1, "Título é obrigatório"),
  description: z.string().min(1, "Descrição é obrigatória"),
  status: z
    .enum(["PENDING", "IN_PROGRESS", "SUSPENDED", "COMPLETED", "CANCELLED"])
    .optional(),
  priority: z.enum(["LOW", "MEDIUM", "HIGH", "URGENT"], {
    message: "Prioridade é obrigatória",
  }),
  priorityJustification: z.string(),
  sectorId: z.string().min(1, "Setor é obrigatório"),
  assignedToId: z.string().min(1, "Responsável é obrigatório"),
  assignedTeamId: z.string().min(1, "Equipe é obrigatória"),
  estimatedStartDate: z
    .string()
    .min(1, "Data de início estimada é obrigatória"),
  estimatedEndDate: z.string().min(1, "Data de término estimada é obrigatória"),
  occurrenceIds: z.array(z.string()),
});

export type UpdateServiceOrderFormData = z.infer<
  typeof updateServiceOrderSchema
>;
